<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-navigation-drawer
            :bottom="true"
            :clipped="true"
            :mini-variant.sync="mini"
            fixed
            app
            color="#222d32"
            dark
            disable-resize-watcher
            enable-resize-watcher
            permanent
            v-model="drawer"
    >
      <v-list-item style="background-color: red">
        <div v-if="mini">
          <img alt="Vue Material Admin" src="../assets/osa.png" style="height: 29px;">
        </div>
        <div v-if="!mini">
          <img alt="Vue Material Admin" src="../assets/osa.png" style= "height: 29px;">
        </div>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-icon>
          <v-icon small>$vuetify.icons.values.mdiAccount</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Qistina Hasim</v-list-item-title>
          <v-list-item-subtitle>Global Psytech</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list dense>
        <router-link to="/dashboard">
          <v-list-item link>
            <v-list-item-icon>
              <v-icon small>$vuetify.icons.values.mdiChartBar</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{$t('msg.sidebar_text_dashboard')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
        <router-link to="/results">
          <v-list-item link>
            <v-list-item-icon>
              <v-icon small>$vuetify.icons.values.mdiChartPie</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{$t('msg.sidebar_text_results')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
        <v-list-item v-if="!mini" class="mt-10">
          <v-list-item-content>
<!--            <v-list-item-title><img alt="Vue Material Admin" src="../assets/gp.png"></v-list-item-title>-->
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
  import { EventBus } from '../main'

  export default {
    name: 'SideBar',
    data () {
      return {
        show: false,
        drawer: true,
        mini: true,
        fav: true,
        menu: false,
        message: false,
        hints: true
      }
    },
    methods: {
      handleLogout: function () {
        window.location.href =  'appLogout'
      },
      handleSideBar: function () {
        this.mini = !this.mini
      }
    },
    created () {
      EventBus.$on('Clicked', this.handleSideBar)
    }
  }

</script>
<style>
  .v-application .primary--text {
    color: white !important;
  }

  .v-application a {
    text-decoration: none;
  }

  .v-application .primary--text {
    color: white !important;
  }

  /*.theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled){*/
  /*  color: red !important;*/
  /*}*/
</style>

